import "@pws/coquille-ui/styles.css";
import { StatusBadge as CoquilleStatusBadge } from "@pws/coquille-ui";
import { injectCoquilleTokens } from "./injectCoquilleTokens.js";

injectCoquilleTokens();

export { CoquilleStatusBadge as StatusBadge };
